export const isUndefined = (value: unknown): value is undefined =>
  value === undefined

export const isNotUndefined = <A>(value: A | undefined): value is A =>
  value !== undefined
